
import Vue from 'vue'

const state = {
  show: false,
  pnoCompany: 'pnod',
};

const getters = {}

const actions = {
  start({ commit }) {
    commit('setState', true)
  },
  async finish({ commit }, callback = null) {
    if (!state.show) {
      if (callback) callback()
    }
    else {
      commit('setState', false)
      setTimeout(function () {
        if (callback) callback()
      }, 1000)
    }
  },
  async login({ commit }) {
    const loginUrl = window.envConfig.AUTH_BASEURL + "?goto=" + window.location
    await actions.finish({ commit }, function () {
      window.location = loginUrl
    })
  },
  async logout({ commit }) {
    const logoutUrl = window.envConfig.AUTH_BASEURL + "/logout?goto=" + window.location
    await actions.finish({ commit }, function () {
      window.location = logoutUrl
    })
  },
  pnoCompanyChange({commit}, value) {
    commit('setPnoCompany', value)
  }
};

const mutations = {
  setState(state, show) {
    state.show = show
  },
  setPnoCompany(state, value) {
    state.pnoCompany = value
    Vue.localStorage.set('pnoCompany', state.pnoCompany)
  }

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
